@switch (messageStatus()) {
  @case ('UNKNOWN') {
    <span class="fa-kit fa-fw fa-pb-circle-solid me-1 text-unknown" [ngClass]="customCssClass()"></span>
  }
  @case ('SAVED') {
    <span class="fa-kit fa-fw fa-pb-circle-pencil me-1 text-saved" [ngClass]="customCssClass()"></span>
  }
  @case ('SCHEDULED') {
    <span class="fa fa-fw fa-clock me-1 pending-status-icon" [ngClass]="customCssClass()"></span>
  }
  @case ('DEADLINE_CLOSE') {
    <span class="fa-kit fa-fw fa-pb-clock-nine-thick me-1 text-warning" [ngClass]="customCssClass()"></span>
  }
  @case ('DEADLINE_MISSED') {
    <span class="fa-kit fa-fw fa-pb-clock-twelve-thick me-1 text-portbase-red" [ngClass]="customCssClass()"></span>
  }
  @case ('SCHEDULED') {
    <span class="fa fa-solid fa-fw fa-clock me-1 text-primary"></span>
  }
  @case ('PENDING') {
    <span class="fa fa-solid fa-fw fa-circle-ellipsis me-1 pending-status-icon" [ngClass]="customCssClass()"></span>
  }
  @case ('DELIVERED') {
    <span class="fa-kit fa-fw fa-pb-circle-arrow-down me-1 pending-status-icon" [ngClass]="customCssClass()"></span>
  }
  @case ('ACCEPTED') {
    <span class="fa-kit fa-fw fa-pb-circle-check-solid me-1 text-portbase-green" [ngClass]="customCssClass()"></span>
  }
  @case ('ACCEPTED_WITH_CONDITIONS') {
    <span class="fa-kit fa-fw fa-pb-circle-comment me-1 text-portbase-green" [ngClass]="customCssClass()"></span>
  }
  @case ('WARNING') {
    <span class="fa-kit fa-fw fa-pb-circle-exclamation-solid me-1 text-warning" [ngClass]="customCssClass()"></span>
  }
  @case ('REJECTED') {
    <span class="fa-kit fa-fw fa-pb-circle-xmark-solid me-1 text-portbase-red" [ngClass]="customCssClass()"></span>
  }
  @case ('ERROR') {
    <span class="fa-kit fa-fw fa-pb-circle-exclamation-solid me-1 text-portbase-red" [ngClass]="customCssClass()"></span>
  }
}
